export class PoStatusUpdate {
}
export class PoStatusUpdateDetails {
    requirementID:any;
    jobNumber:string;
    rmhName:string;
    rmhId:string;
    requirementType:string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string;
    finalQuantity:string;
    wHLocation:string;
    quantity:any;
    poNumber:any;
    poIssuedDate:any;
    vendorType:string;
    orderStatus:string;
    poIssueQty:any;
    rollingYear:string;
}

export class PoStatusUpdateFilters {
    jobNumbers:jobNumber[];
    rmhs:RMH[];
    jobTypes:JobType[];
    brands:Brand[];
    crops:Crop[];
    languages:Language[];
    orderStatus:RequirementStatus[];
    states:State[];
    maMapping:MaMapping[];
    mapping : stateMapping[];
    Vendor:Vendor[];
    currentRequirementYear: CurrentRequirementYear[];
}
export class CurrentRequirementYear{
    year:string;
    currentrequirementYear:string;
}
export class Vendor{
    id:Number;
    vendorType:string;
}
export class jobNumber{
    jobNumberID:string;
    jobNumberName:string;
    rMHCode:string;
    brandID: string;
    jobTypeID:number;
    cropID:number;
    languageID:number;
    stateName: string;
    month : string;
    statusID : string;
}

export class RMH{
    rMHCode:string;
    rMHName:string;
}

export class Brand{
    brandID:string;
    brandName:string;
}

export class JobType{
    jobTypeID:number;
    jobTypeName:string;
}

export class Crop{
    cropID:number;
    cropName:string;
}

export class Language{
    languageID:number;
    languageName:string;
}

export class RequirementStatus{
    requirementStatusID:number;
    requirementStatusName:string;
}

export class State{
    stateID:string;
    stateName:string;
}

export class UpdatedPODetails{
    RequirementID:any;
    Quantity:string;
    PONumber:any;
    POIssuedDate:Date;
    RequirementType:string;
}

export class MaMapping{
    rMHCode:string;
    stateName:string;
    ma:string;
}

export class stateMapping{
    languageID : number;
    languageName : string;
    state : string;
}
export class poApprovalDetail
{
    id:number;
    jobNumber:string;
    vendorType:number;
    vendorName:string;
    approvedQuantity:number;
    poNumber:string;
    poQuantity:number;
    poIssuedDate:Date;
    remainingQuantity:number;
    EstimateDeliveryToWH:any;
    cancelationApproval:number;
}